// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header__text-3eV4N";
var _3 = "close-227Pf";
var _4 = "message_restrictionsRejectSeats-2XNVo";
export { _1 as "__esModule", _2 as "header__text", _3 as "close", _4 as "message_restrictionsRejectSeats" }
export default { "__esModule": _1, "header__text": _2, "close": _3, "message_restrictionsRejectSeats": _4 }
